import React from 'react';
import { DeleteDecumulationGoal } from './components/DeleteDecumulationGoal/DeleteDecumulationGoal';
import { GoalComponentProps } from '../../components/Goal/Goal.meta';

export const Decumulation = ({ clientId, id, onClose }: GoalComponentProps) => {
  if (!id) {
    return null;
  }

  return <DeleteDecumulationGoal clientId={clientId} goalId={id} onClose={onClose} />;
};
